import React, { useCallback } from 'react';
import {
  Button,
  CircularProgress,
  makeStyles,
  Typography,
} from '@material-ui/core';
import { useDropzone } from 'react-dropzone';

const useStyles = makeStyles(() => ({
  text: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: 1.31,
    letterSpacing: '0.16px',
    color: '#000000',
    opacity: 0.6,
    margin: 0,
    marginBottom: 12,
  },
  subText: {
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 1.29,
    letterSpacing: '0.16px',
    color: '#000000',
    margin: '0 0 12px',
    opacity: 0.6,
  },
  button: {
    padding: '6px 17px 7px 18px',
    borderRadius: '16px',
    border: 'solid 1px rgba(0, 0, 0, 0.12)',
    backgroundColor: '#ffffff',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: 1.36,
    letterSpacing: '0.25px',
    color: 'rgba(0, 0, 0, 0.87)',
    textTransform: 'none',
  },
  progress: {
    marginLeft: 8,
  },
}));

const Dropzone = ({
  multiple = true,
  // accept = '.pdf, .txt, .zip, .doc, .docx',
  accept = '',
  text = '',
  subtext = '',
  handleDrop,
  isLoading = false,
  disabled = false,
}) => {
  const classes = useStyles();

  const baseStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    border: '1px dashed #4b8c6f',
    outline: 'none',
    transition: 'border .24s ease-in-out',
    height: '140px',
    cursor: 'pointer',
    marginBottom: '16px',
    backgroundColor: 'rgba(223, 239, 232, 0.63)',
  };

  const isDisabledStyle = {
    cursor: 'progress',
  };

  const activeStyle = {
    borderColor: '#4b8c6f',
  };

  const acceptStyle = {
    borderColor: '#4b8c6f',
  };

  const rejectStyle = {
    borderColor: '#4b8c6f',
  };

  const onDrop = useCallback(
    (acceptedFiles, errorFiles) => {
      console.log('errorFiles: ', errorFiles);
      handleDrop(acceptedFiles, errorFiles);
    },
    [handleDrop]
  );

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept,
    multiple,
    disabled: disabled || isLoading,
  });

  const style = {
    ...baseStyle,
    ...(isDragActive ? activeStyle : {}),
    ...(isDragAccept ? acceptStyle : {}),
    ...(isDragReject ? rejectStyle : {}),
    ...(isLoading ? isDisabledStyle : {}),
  };

  return (
    <div {...getRootProps({ style })}>
      <input {...getInputProps()} />
      <Typography classes={{ root: classes.text }}>{text}</Typography>
      {subtext && (
        <Typography classes={{ root: classes.subText }}>{subtext}</Typography>
      )}
      <Button
        classes={{ root: classes.button }}
        title="Select File"
        disabled={disabled || isLoading}
      >
        Select File{' '}
        {isLoading ? (
          <CircularProgress
            size={16}
            color="primary"
            classes={{ root: classes.progress }}
          />
        ) : (
          ''
        )}
      </Button>
    </div>
  );
};

export default Dropzone;
